import { Text } from '@avanta/shared/components/Text';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { CircleAlert } from 'lucide-react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router';
import { ROUTES } from 'constants/routes';
import { AppointmentsReservePayload } from 'pages/AppointmentsReserve/constants';
import { type AppointmentsReserveFormData } from 'pages/AppointmentsReserve/types';

export const NoScheduleBanner = (): React.ReactElement | null => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);
  const { control } = useFormContext<AppointmentsReserveFormData>();
  const patient = useWatch({ control, name: AppointmentsReservePayload.patient });
  const patientId = patient?.id ?? '';

  if (!patientId) return null;

  return (
    <div role="alert" className="col-span-2 flex items-start gap-4 rounded-xl bg-red-100 p-4">
      <CircleAlert aria-hidden className="size-6 shrink-0 text-red-400" strokeWidth={1.25} />
      <div className="flex min-w-0 flex-col gap-1">
        <Text variant="text-sm-medium" className="text-denim-500">
          {t('AppointmentsReserve.NoScheduleBanner.title')}
        </Text>
        <Text variant="text-sm-regular" className=" text-gray-500">
          {t('AppointmentsReserve.NoScheduleBanner.description')}
        </Text>
        <Link to={generatePath(ROUTES.PATIENT_PROFILE, { id: patientId })} className="w-fit ">
          <Text
            variant="text-sm-medium"
            className="text-teal-600 underline underline-offset-2 hover:text-teal-500"
          >
            {t('AppointmentsReserve.NoScheduleBanner.cta')}
          </Text>
        </Link>
      </div>
    </div>
  );
};
